export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50 relative overflow-hidden">
      {/* Decorative line art */}
      <div className="absolute top-0 left-8 w-32 h-32 opacity-[0.06] pointer-events-none">
        <div className="w-full h-full rounded-full border-2 border-foreground-900"></div>
        <div className="absolute top-4 left-4 w-24 h-24 rounded-full border border-foreground-900"></div>
      </div>

      <div className="relative flex flex-col lg:flex-row items-center gap-0">
        {/* Left Image - overlaps outside card */}
        <div className="lg:w-2/5 flex-shrink-0 -mb-12 lg:-mb-0 lg:-mr-16 z-10">
          <div className="w-64 h-80 md:w-80 md:h-96 mx-auto rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20young%20person%20in%20neutral%20beige%20hoodie%20against%20soft%20grey%20textured%20wall%20minimal%20editorial%20fashion%20photography%20warm%20natural%20light%20clean%20composition%20airy%20aesthetic&width=800&height=1000&seq=testimonial-portrait-gtbuy&orientation=portrait"
              alt="GTBuy Sheet community member review"
              title="GTBuy Sheet User Testimonial"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Right - Testimonial Card */}
        <div className="lg:w-3/5 w-full bg-foreground-900 rounded-2xl md:rounded-3xl p-8 md:p-14 lg:pl-24">
          <div className="text-accent-300 text-5xl md:text-7xl font-heading leading-none mb-4">
            &ldquo;
          </div>
          <p className="text-background-100 text-base md:text-xl leading-relaxed font-light max-w-lg">
            GTBuy Sheet completely changed how I shop for streetwear. The spreadsheet
            format makes it insanely easy to compare prices across categories. I have found
            deals I would have never discovered on my own. The weekly updates keep everything
            fresh &mdash; this is hands down the best shopping tool out there.
          </p>
          <div className="mt-8 space-y-1">
            <p className="text-background-50 text-sm font-semibold">Marcus J.</p>
            <p className="text-background-400 text-xs">Verified Spreadsheet User · NYC</p>
          </div>
          <div className="mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-block px-6 py-2.5 rounded-full bg-accent-100 text-accent-800 text-sm font-semibold hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read More Reviews
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}